import { setOptions } from './internal/index.js';

function configure (options) {
  setOptions(options);
}

export default configure;



// WEBPACK FOOTER //
// ./imageLoader/configure.js